import {Component, Input} from '@angular/core';
import {ImageFallbackDirective} from "../../../image-fallback.directive";
import {ProfileImageComponent} from "../profile-image/profile-image.component";
import {NgForOf} from "@angular/common";
import {ProfileImage} from "../model/profile";

@Component({
    selector: 'group-profile-image',
    templateUrl: './group-profile-image.component.html',
    imports: [
        ProfileImageComponent,
        NgForOf
    ],
    styleUrls: ['./group-profile-image.component.css']
})
export class GroupProfileImageComponent {
    @Input()
    images: (ProfileImage)[] = [];
}
